import React from "react";
import "./styles.scss";

export default function Gender(props) {
  /* eslint eqeqeq: 0 */
  const { gender, setGender = () => {} } = props;

  const genders = [
    { id: null, value: "未設定" },
    { id: 1, value: "男　性" },
    { id: 2, value: "女　性" },
    { id: 3, value: "その他" },
    { id: 4, value: "未回答" }
  ];
  
  const handleChangeGender = (e) => {
    setGender(e.target.value);
  };
  
  return (
    <div>
      {genders?.map((item, index) => (
        <div className="radio" key={item.id}>
          <input
            id={index + 1}
            name="gender"
            type="radio"
            checked={gender === null ? index == 0 : index == gender}
            value={item.id || ""}
            onChange={(e) => handleChangeGender(e)}
          />
          <label htmlFor={index + 1} className="radio-label">
            {item.value}
          </label>
        </div>
      ))}
    </div>
  );
}
